import React from 'react';
import './App.css';
import {
	BrowserRouter as Router, 
	Route, 
	Switch
} from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import FlixNavbar from './components/FlixNavbar.js';
import FlixFooter from './components/FlixFooter.js';
import FlixCreate from './components/Pages/FlixCreate/FlixCreate.js';
import FlixFilter from './components/Pages/FlixList/FlixFilter.js';
import MovieDetail from './components/Pages/FlixDetail/MovieDetail.js';
import SeriesDetail from './components/Pages/FlixDetail/SeriesDetail.js';
import WatchTogetherRoom from './components/Pages/WatchTogether/WatchTogetherRoom.js';
import NotFound from './components/Pages/NotFound.js';
import { TMDBProvider } from './contexts/TMDBContext.js';
import { FlixProvider } from './contexts/FlixContext.js';

const PrivateRoute = ({ children, ...rest }) => {
	const { isAuthenticated, isLoading } = useAuth();
	if (isLoading) return null;
	return (
		<Route {...rest}>
			{isAuthenticated ? children : <NotFound />}
		</Route>
	);
};

const DetailProviders = ({ children }) => (
    <TMDBProvider>
        <FlixProvider>
            {children}
        </FlixProvider>
    </TMDBProvider>
);

function App() {
  return (
  	<AuthProvider>
	  	<React.Fragment>
	  		<div className="main-background"></div>
		    <div className="main-container">
		    	<Router>
					<FlixNavbar />
					<div>
						<div className="inner-container d-flex flex-column w-100">
							<Switch>
								<Route exact path="/">
									<FlixFilter />
								</Route>
								<Route exact path="/flix/movie/:flix_id/:tmdb_id">
									<DetailProviders><MovieDetail /></DetailProviders>
								</Route>
								<Route exact path="/flix/series/:flix_id/:tmdb_id">
									<DetailProviders><SeriesDetail /></DetailProviders>
								</Route>
								<PrivateRoute exact path="/flix/create">
									<DetailProviders>
										<FlixCreate />
									</DetailProviders>
								</PrivateRoute>
								<Route exact path="/watch-together/:roomId">
									<WatchTogetherRoom />
								</Route>
								<Route path="*">
									<NotFound />
								</Route>
							</Switch>
							<FlixFooter />
						</div>
					</div>
				</Router>
			</div>
	  	</React.Fragment>
  	</AuthProvider>
  );
}

export default App;